import './MonitoredObjects.scss';
import { CHANGE_EVENT_PREFERENCES } from '@sonar-software/sonar-ts-constants';
import { DisabledAlert } from './DisabledAlert';
import { List } from 'antd';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { MonitoredObjectsButtons } from './MonitoredObjectsButtons';
import { NoObjectsAlert } from './NoObjectsAlert';
import React from 'react';
import { SonarText } from '@ui/text';
import { Else, If, Then, When } from 'react-if';
export const MonitoredObjects = ({ onRefresh, isEnabled, loading, monitoredObjects, refreshing, salesforceUrl }) => {
    var _a;
    const renderItem = (item) => React.createElement(List.Item, null, item);
    const hasData = Boolean(monitoredObjects === null || monitoredObjects === void 0 ? void 0 : monitoredObjects.totalCount);
    const failed = !loading && !monitoredObjects;
    return (React.createElement("div", { className: 'selected-objects' },
        React.createElement(If, { condition: loading },
            React.createElement(Then, null,
                React.createElement(LoadingSpinner, { spinning: loading })),
            React.createElement(Else, null,
                React.createElement(If, { condition: isEnabled },
                    React.createElement(Then, null,
                        React.createElement(If, { condition: hasData },
                            React.createElement(Then, null,
                                React.createElement(SonarText, null, CHANGE_EVENT_PREFERENCES.SELECTED_LIMITS),
                                React.createElement(MonitoredObjectsButtons, { onRefresh: onRefresh, refreshing: refreshing, salesforceUrl: salesforceUrl }),
                                React.createElement(LoadingSpinner, { spinning: refreshing },
                                    React.createElement(List, { dataSource: monitoredObjects === null || monitoredObjects === void 0 ? void 0 : monitoredObjects.entityDefinitions, 
                                        // eslint-disable-next-line max-len
                                        header: CHANGE_EVENT_PREFERENCES.OBJECTS_MONITORED((_a = monitoredObjects === null || monitoredObjects === void 0 ? void 0 : monitoredObjects.totalCount) !== null && _a !== void 0 ? _a : 0), itemLayout: 'vertical', renderItem: renderItem, size: 'small' }))),
                            React.createElement(Else, null,
                                React.createElement(NoObjectsAlert, { failed: failed, onRefresh: onRefresh }),
                                React.createElement(When, { condition: !failed },
                                    React.createElement(MonitoredObjectsButtons, { onRefresh: onRefresh, refreshing: refreshing, salesforceUrl: salesforceUrl }))))),
                    React.createElement(Else, null,
                        React.createElement(DisabledAlert, null),
                        React.createElement(MonitoredObjectsButtons, { onRefresh: onRefresh, refreshing: refreshing, salesforceUrl: salesforceUrl })))))));
};
